import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export function MostSharedPieces({ b }: any) {
  const [items, setItems] = useState<any[]>([]);
  useEffect(() => { api.get("/products-most-shared", { params: { limit: Number(b.count) || 4, days: 30 } }).then((r) => setItems(r.data)).catch(() => {}); }, [b.count]);
  if (!items.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-12 py-16 md:py-20" data-testid="most-shared-pieces-block">
      <div className="text-center mb-12">
        <h2 className="font-display uppercase text-3xl md:text-[2.4rem] tracking-[0.04em]">{b.heading || "Most Shared Pieces"}</h2>
        {b.subheading && <p className="mt-3 text-sm md:text-base text-neutral-600">{b.subheading}</p>}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12 md:gap-x-8" data-testid="most-shared-pieces-grid">
        {items.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
      </div>
    </section>
  );
}
